import { format } from 'date-fns'

const DATES_SEPARATOR = '|' as const
const ALC_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss" as const
const ALC_DATE_REGEXP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/

type ALCDateString = `${string}-${string}-${string}T${string}:${string}:${string}`
type ALCDateRangeString = `${ALCDateString}${typeof DATES_SEPARATOR}${ALCDateString}`
type SeparatedALCDates = [ALCDateString | undefined, ALCDateString | undefined]
type DateType = Date | null
type DatesType = [DateType, DateType]

const toALC = (date: DateType) => (date && format(date, ALC_DATE_FORMAT)) ?? undefined

export const datesToALC = ([startDate, endDate]: DatesType) => {
  if (!startDate || !endDate) return ''

  return `${toALC(startDate)}${DATES_SEPARATOR}${toALC(endDate)}` as ALCDateRangeString
}

export const separateALC = (value: string): SeparatedALCDates => {
  if (!value) return [undefined, undefined]
  const values = value.split(DATES_SEPARATOR)

  if (values.length !== 2) return [undefined, undefined]

  const [startDate, endDate] = values

  const isValidStartDate = ALC_DATE_REGEXP.test(startDate)
  const isValidEndDate = ALC_DATE_REGEXP.test(endDate)

  if (!isValidStartDate || !isValidEndDate) return [undefined, undefined]

  return [startDate as ALCDateString, endDate as ALCDateString]
}

export const alcToDates = (value: string): DatesType => {
  const [startDate, endDate] = separateALC(value)

  return [startDate ? new Date(startDate) : null, endDate ? new Date(endDate) : null]
}

export const datesToLabel = ([startDate, endDate]: DatesType) =>
  `${startDate ? format(startDate, 'dd/MM/yyyy') : ''} - ${endDate ? format(endDate, 'dd/MM/yyyy') : ''}`
